export default {
  title: 'Copagamento',
  description: 'O copagamento é um valor fixo em dólares que tem de pagar por serviços de saúde ou medicamentos cobertos, conforme definido pelo seu plano de seguro.',
  'is-paid': 'está pago',
}
